import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, ReferenceLine } from "recharts";

export const ProgressChart = ({ points, height = 300 }) => {
  if (!points.length) {
    return <div data-testid="progress-chart-empty" className="flex h-48 items-center justify-center text-sm text-slate-400">Belum ada nilai yang tercatat.</div>;
  }
  return (
    <div data-testid="progress-chart">
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={points.map((p, i) => ({ ...p, idx: i + 1 }))} margin={{ top: 10, right: 20, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
          <XAxis dataKey="idx" tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} label={{ value: "Urutan penilaian", position: "insideBottom", offset: -2, fontSize: 11, fill: "#94a3b8" }} />
          <YAxis domain={[0, 10]} tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
          <ReferenceLine y={7} stroke="#f59e0b" strokeDasharray="4 4" label={{ value: "Batas 7.0", fontSize: 10, fill: "#f59e0b", position: "insideTopRight" }} />
          <Tooltip
            contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 12 }}
            formatter={(val, name) => [val, name === "final_score" ? "Nilai Akhir" : "Nilai Tugas"]}
            labelFormatter={(i) => { const p = points[i - 1]; return p ? `${p.label} (${p.date})` : ""; }}
          />
          <Line type="monotone" dataKey="final_score" stroke="#25499B" strokeWidth={2.5} dot={{ r: 3, fill: "#25499B" }} name="final_score" />
          <Line type="monotone" dataKey="score" stroke="#F16522" strokeWidth={1.5} strokeDasharray="5 4" dot={{ r: 2 }} name="score" />
        </LineChart>
      </ResponsiveContainer>
      <div className="mt-3 flex flex-wrap items-center justify-center gap-6 text-xs text-slate-500">
        <span className="flex items-center gap-1.5"><span className="h-2.5 w-4 rounded bg-[#25499B]" /> Nilai Akhir (kumulatif)</span>
        <span className="flex items-center gap-1.5"><span className="h-0.5 w-4 bg-[#F16522]" /> Nilai tiap tugas</span>
      </div>
    </div>
  );
};
